module.exports = __webpack_public_path__ + "static/media/disc_2x.766dde43.png";